import React, {useState} from 'react';
import classnames from "classnames";
import assets from "../../../util/assets";
import moment from "moment";
import "./index.css";
import {Popover, PopoverBody} from 'reactstrap';
import DropdownItem from "../../clipstore/broadcaster/library/dropdown-item/DropdownItem";
import AttachmentGriView from "../attachment-grid-view";

ChatWindowBubble.propTypes = {

};

function ChatWindowBubble(props) {
    const [popoverOpen, setPopoverOpen] = useState(false);
    const toggle = () => setPopoverOpen(!popoverOpen);

    const [style, setStyle] = useState({visibility: 'hidden'});
    const messagingBubble = classnames({
        "direct-messaging-left-bubble": props.position === "left" && !props.currentMessage.data,
        "direct-messaging-right-bubble": props.position === "right" && !props.currentMessage.data,
        "direct-messaging-left-bubble-with-attachment": props.position === "left" && props.currentMessage.data,
        "direct-messaging-right-bubble-with-attachment": props.position === "right" && props.currentMessage.data
    })

    return (
        <div className="display-flex cursor-pointer" key={`direct-messaging-bubble-${props.currentMessage.id}`}
             onMouseEnter={e => {
                 setStyle({visibility: 'visible'});
             }}
             onMouseLeave={e => {
                 setStyle({visibility: 'hidden'})
             }}>

            <Popover placement="bottom" isOpen={popoverOpen}
                     target={`direct-messaging-bubble-hover-${props.currentMessage.id}`} toggle={toggle}
                     className="chat-window-detail-header-popover">
                <PopoverBody className="my-library-actions-pop-over-body">

                    <div>
                        <DropdownItem
                            key={`direct-messaging-bubble-hover-item-${props.currentMessage.id}`}
                            onClick={() => {
                                toggle();
                                console.log("Delete Message")
                                props.deleteMessageByID(props.currentMessage)
                            }}
                            icon={assets.messaging.dropdown.delete_chat}
                            text={"Delete Message"}
                        />
                    </div>
                </PopoverBody>
            </Popover>

            {/*{*/}
            {/*    props.position === "left" &&*/}
            {/*    <img src={assets.messaging.message_bubble_left}*/}
            {/*         alt={"left bubble"}*/}
            {/*         className="direct-messaging-left-bubble-img"/>*/}
            {/*}*/}

            <div className={messagingBubble}>
                <div className="display-flex">
                    <div>
                        {
                            props.currentMessage.data ?
                            <AttachmentGriView currentMessage={props.currentMessage} attachmentClicked={props.attachmentClicked}/>
                            :
                                <div className="message-text">
                                    {props.currentMessage.text}
                                </div>
                        }
                    </div>
                    <img style={style}
                         id={`direct-messaging-bubble-hover-${props.currentMessage.id}`}
                         className="direct-messaging-caret"
                         src={assets.messaging.caret}
                         alt={"caret"}
                         onClick={() => {
                             console.log("caret")
                             toggle()
                         }}/>
                </div>
                <div className="direct-messaging-time">
                    {moment(props.currentMessage.createdAt).format("hh:mm")}
                </div>
            </div>

            {/*{props.position === "right" && <img src={assets.messaging.message_bubble_right} alt={"left bubble"}*/}
            {/*                                    className="direct-messaging-right-bubble-img"/>}*/}
        </div>
    )
}

export default ChatWindowBubble;